import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';
import { Subscription } from 'rxjs';
import { SpinnerService } from 'src/app/core/services/spinner.service';
import { SignUpService } from 'src/app/pages/sign-up/services/sign-up.service';
import { LeadService } from 'src/app/pages/lead/services/lead.service';
import { takeUntil } from 'rxjs/operators';
import { CrudService } from 'src/app/services/crud.service';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-mat-confirm-void',
    templateUrl: './mat-confirm-void.component.html',
    styleUrls: ['./mat-confirm-void.component.scss'],
    standalone: false
})
export class MatConfirmVoidComponent implements OnDestroy {
  // message: string = ""
  confirmButtonText = "Yes"
  cancelButtonText = "Cancel"
  subscriptions: Subscription[] = [];
  titleMsg: string;
  titleMsgs: string;
  ItemsDeleteModule:any;
  type
  titleMsgNew:any
  msgFromAgenda
  msgFromDeal: boolean = false;
  tableDelete: boolean = false;
  itemDelete: boolean = false;


  constructor(
    @Inject(MAT_DIALOG_DATA) private data: any,
    private dialogRef: MatDialogRef<MatConfirmVoidComponent>,
    private signupService: SignUpService,
    private spinner: SpinnerService,
    public snackbar: MatSnackBar,
    public leadService: LeadService,
    private activity:CrudService,
    private translateService: TranslateService
    ) {}

  ngOnInit() {    
  if(this.data?.title){
    this.titleMsg = this.data?.title;
    }
  }


  closeModel() {
    this.dialogRef.close(false);
  }



  ngOnDestroy(): void {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  getTranslatedText(key: string): string {    
    const translation = this.translateService.instant(key);
    return translation !== key ? translation : '';
  }

  onConfirmClick(): void {
    this.dialogRef.close(true)
  }
}
